var map = {
	"./altaConcurrencia.svg": 1711,
	"./bird.svg": 7575,
	"./blockchain.svg": 5618,
	"./capacitacion.svg": 3383,
	"./cultura.svg": 1426,
	"./datos.svg": 9127,
	"./fullstack.svg": 8003,
	"./homepage.svg": 4968,
	"./homepageCulture.svg": 6518,
	"./homepageLabs.svg": 8703,
	"./inteligenciaArtificial.svg": 9951,
	"./labs.svg": 8388,
	"./mapa_argentina.svg": 7782,
	"./page404.svg": 5251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3094;